<template>
	<div class="rootDiv">
		<div class="retrieve">
			<div class="searchDiv flex flex-jb flex-ac">
				<div>
					<span>用户名：</span>
					<el-input class="w-150" v-model="retrieveForm.userName" clearable @clear="clearInput"></el-input>
				</div>
				<div>
					<span>手机号：</span>
					<el-input class="w-150" v-model="retrieveForm.fbdPhone" clearable @clear="clearInput"></el-input>
				</div>
				<div>
					<span>问题类型：</span>
					<el-select class="w-150" v-model="retrieveForm.fbdType" clearable @clear="clearInput">
						<el-option v-for="item in fdbTypes" :key="item.label" :label="item.key" :value="item.value"></el-option>
					</el-select>
				</div>
				<div>
					<span>处理状态：</span>
					<el-select class="w-100" v-model="retrieveForm.fbdStatus" clearable @clear="clearInput">
						<el-option v-for="item in fbdStatus" :key="item.label" :label="item.key" :value="item.value"></el-option>
					</el-select>
				</div>
				<div class="mr-30 flex flex-ac">
					<span class="fs-16 flex1 mr-20 w-80">创建时间：</span>
					<el-date-picker class="w-250" v-model="startEndDate" type="daterange" valueFormat="yyyy-MM-dd HH:mm:ss"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handPickerChange">
					</el-date-picker>
				</div>
				<div label="" class="mr-10" @keydown="submitSearch">
					<el-button type="primary" @click="submitSearch">查询</el-button>
				</div>
			</div>
			<TableHeightFull class="tableDiv pall-30">
				<!-- 表格 -->
				<EleTable ref="tableRef" slot="table" :tableData="tableData" :columns="columns" height="100%" :border="false"
					v-loading="tabLoading" :row-style="{ cursor: 'pointer' }" :span-method="arraySpanMethod">
					<template v-slot:img="scope">
						<img :src="scope.row.userImg" alt="" class="smallImg" v-if="scope.row.userImg">
					</template>
				</EleTable>
				<!-- 分页 -->
				<PagingComponent slot="after" :page-info="pageInfo" @getTableData="getTableData" />
			</TableHeightFull>
		</div>
		<el-dialog title="回复" :visible.sync="replyDialog" width="40%">
			<div class="flex flex-jb flex-ac">
				<div class="fs-14">投诉人：<span class="fw-bold">{{feedData.userName}}</span></div>
				<div class="fs-14">微信号：<span class="fw-bold">{{feedData.wechatNum}}</span></div>
			</div>
			<div class="mt-30 flex flex-jb flex-ac">
				<div class="fs-14">投诉类型：<span class="fw-bold">{{formatConfigs(feedData.fdbType)}}</span></div>
				<div class="fs-14">手机号：<span class="fw-bold">{{feedData.fdbPhone}}</span></div>
			</div>
			<div class="mt-30">
				<div class="fs-14">投诉内容：</div>
<!-- 				<el-input v-model="feedData.userDescr" type="textarea" :rows="3"
					disabled></el-input> -->
				<div class="fs-14 mt-10 height-85" style="height: 85px;background-color: #F5F7FA;color: #000000;">{{feedData.userDescr}}</div>
			</div>
			<div class="flex flex-ac mt-20 mb-20" v-if="feedData.fdbImg">
				<span class="mr-20">反馈图片</span>
				<UploadFile upStyle="width: 80px; height: 80px; border-radius: 5px; overflow: hidden;"
					iconName="el-icon-upload" iconSize="26" :showRemove='false' v-model="feedData.fdbImg"></UploadFile>
			</div>
			<hr />
			<div class="mt-10">
				<div class="fs-14 mb-10 flex flex-ac flex-jb">
					<div v-if="feedData.custRespond">回复账号：<span class="fw-bold">{{feedData.custRespond.custUserName}}</span></div>
					<div class="" v-if="feedData.custRespond">回复时间：<span class="fw-bold">{{feedData.custRespond.fdbDate}}</span>
					</div>
					<span>回复内容：</span>
				</div>
				<el-input v-if="feedData.custRespond" v-model="feedData.custRespond.custDescr" type="textarea" :rows="3"
					disabled></el-input>
				<el-input v-model="custDescr" type="textarea" :rows="3" v-else></el-input>
			</div>
			<div class="flex flex-ac flex-je mt-10" v-if="feedData.solveDate">
				<div class="fs-14">结单人：<span class="fw-bold">{{feedData.doneCustUserName}}</span></div>
				<div class="ml-30 fs-14">结单时间：<span class="fw-bold">{{feedData.solveDate}}</span></div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="consumeCancel">取 消</el-button>
				<el-button type="primary" @click="consumeFirm" :loading="butLoading" v-if="!feedData.custRespond">确
					定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import indexMixin from "@/utils/indexMixin"
	import {
		mapState
	} from 'vuex'
	export default {
		name: 'userGrade',
		mixins: [indexMixin],
		components: {
			"EleTable": (resolve) => require(["@/components/public/TSimpleTable"], resolve),
			"TableHeightFull": (resolve) => require(["@/components/public/TableHeightFull"], resolve),
			"PagingComponent": (resolve) => require(["@/components/public/PagingComponent"], resolve),
			"UploadFile": (resolve) => require(["@/components/UploadFile"], resolve),
		},
		computed: {
			...mapState('menu', {
				'fdbTypes': state => state.dictList ? state.dictList.fdb_type : [], //优惠劵类型
			}),
		},
		data() {
			return {
				retrieveForm: {
					userName: '',
					fbdPhone: '',
					fbdType: '',
					fbdStatus: '',
					startDate: '',
					endDate: ''
				},
				startEndDate: [], //时间区间
				replyDialog: false,
				butLoading: false,
				tabLoading: false,
				editData: '',
				tableData: [],
				feedData: '',
				custDescr: '', //回复内容
				custRespond: '', //回复人信息
				fbdStatus: [{
						value: 0,
						key: '待处理'
					},
					{
						value: 1,
						key: '处理中'
					},
					{
						value: 2,
						key: '已处理'
					}
				],
				columns: [{
						type: 'index',
						label: '序号',
						width: '60',
						align: 'center',
						fixed: 'left'
					},
					{
						label: '用户名',
						prop: 'userName',
						width: 200,
						align: 'left'
					},
					{
						columnType: 'custom',
						label: '头像',
						prop: 'img',
						align: 'left',
						width: '80',
						'show-overflow-tooltip': true
					},
					// { label: '用户名', prop: 'consume', align: 'left' },
					// { label: '头像', prop: 'consume', align: 'left' },
					{
						label: '手机号',
						prop: 'fdbPhone',
						align: 'left'
					},
					{
						label: '投诉类型',
						prop: 'fdbType',
						align: 'left',
						formatData: (e) => {
							let ele = this.fdbTypes.find(ele => ele.value == e)
							return ele ? ele.key : e
						}
					},
					{
						type: 'Status',
						label: '状态',
						prop: 'fbdStatus',
						align: 'left',
						formatData: (e) => {
							let ele = this.fbdStatus.find(ele => ele.value == e)
							return ele ? ele.key : e
						}
					},
					{
						label: '创建时间',
						prop: 'createDate',
						width: '200',
						align: 'left',
						'show-overflow-tooltip': true
					},
					{
						columnType: 'button',
						label: '操作',
						align: 'right',
						fixed: 'right',
						buttons: [{
							type: 'text',
							text: '回复',
							fn: this.replyMess,
						}, {
							type: 'text',
							text: '结单',
							fn: this.replyEnd,
							hidden: (e) => {
								return e.fbdStatus == 1
							}
						}],
					}
				]
			}
		},
		mounted() {
			this.getTableData()
		},
		methods: {
			formatConfigs(val) {
				if (val || val === 0) {
					let type = this.fdbTypes.find(ele => ele['value'] == val)
					return type.key
				}
			},
			submitSearch() {
				this.pageInfo.pageNum = 1
				this.getTableData()
			},
			getTableData() {
				this.$http.get('/appletUserFeedback/findAppletUserFeedbackList', {
					params: {
						currentPage: this.pageInfo.pageNum,
						pageSize: this.pageInfo.pageSize,
						...this.retrieveForm
					}
				}).then(({
					data: result
				}) => {
					this.tabLoading = false
					this.tableData = result.data.list
					this.pageInfo.total = result.data.total
				})
			},
			clearInput() {
				this.getTableData()
			},
			consumeFirm() {
				if (!this.custDescr) return
				this.$confirm('您确认回复该内容嘛？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(_ => {
					// this.butLoading = true
					this.$http.post('/appletUserFeedback/userRespond', {
						descr: this.custDescr,
						id: this.editData.id
					}).then(_ => {
						this.$message({
							message: '回复成功',
							type: 'success'
						})
						// this.butLoading = false
						this.getTableData()
						this.custDescr = ''
						this.replyDialog = false
					})
				})
			},
			handPickerChange(value) {
				if (value && value.length != 0) {
					this.retrieveForm.startDate = value[0]
					this.retrieveForm.endDate = value[1]
				} else {
					this.retrieveForm.startDate = ""
					this.retrieveForm.endDate = ""
				}
			},
			findAppletUserFeedbackById() {
				this.$http.get(`/appletUserFeedback/findAppletUserFeedbackById?id=${this.editData.id}`).then(({
					data: res
				}) => {
					this.feedData = res.data
					this.$nextTick(() => {
						this.replyDialog = true
					})
				})
			},
			replyMess(row) {
				this.editData = row
				this.findAppletUserFeedbackById()
			},
			replyEnd(row) {
				this.$confirm('确认完结该投诉吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(_ => {
					this.$http.post('/appletUserFeedback/doneFeedback', {
						id: row.id
					}).then(_ => {
						this.getTableData()
					})
				})
			},
			consumeCancel() {
				this.replyDialog = false
			},
			//合并行或列
			arraySpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 1 || columnIndex === 2) {
					var spanArr = this.getSpanArr(this.tableData, 'level')
					const _row = spanArr[rowIndex]
					const _col = _row > 0 ? 1 : 0
					return {
						rowspan: _row,
						colspan: _col
					}
				}
			},
			// 处理合并行的数据
			getSpanArr(data, spanKey) {
				var spanArr = []
				var pos = ''
				for (var i = 0; i < data.length; i++) {
					if (i === 0) {
						spanArr.push(1)
						pos = 0
					} else {
						// 判断当前元素与上一个元素是否相同
						if (data[i][spanKey] === data[i - 1][spanKey]) {
							spanArr[pos] += 1
							spanArr.push(0)
						} else {
							spanArr.push(1)
							pos = i
						}
					}
				}
				return spanArr
			},
		},
	}
</script>

<style>
	.sub_line {
		width: 2px;
		height: 150px;
		background-color: #eeeeee;
	}
</style>